import React, { useState, useEffect } from 'react'
import { Filter, FilterComponent } from '../../components/_WMS/FilterComponent'
import { filterOptions } from './config'
import { Box, Paper, Typography } from '@mui/material'
import WarningIcon from '@mui/icons-material/Warning'
import { FilterExtraAction } from '../../components/_WMS/FilterComponent/types'

interface StockMovementSearchProps {
  onSearchClick: (filters: Filter[]) => void
  selectedFilters: Filter[]
  setSelectedFilters: React.Dispatch<React.SetStateAction<Filter[]>>
  includeAddButton?: boolean
  extraActions?: FilterExtraAction[]
}

export const StockMovementSearch: React.FC<StockMovementSearchProps> = (
  props
) => {
  const [showValidationAlert, setShowValidationAlert] = useState(true)

  // Función para validar si al menos uno de los filtros obligatorios está presente
  const validateRequiredFilters = (filters: Filter[]): boolean => {
    const requiredFilterKeys = ['sku', 'ean13', 'pickingRouteId', 'asnId']
    return filters.some((filter) => requiredFilterKeys.includes(filter.key))
  }

  // Función personalizada para manejar la búsqueda con validación
  const handleSearchWithValidation = (filters: Filter[]) => {
    if (validateRequiredFilters(filters)) {
      setShowValidationAlert(false)
      props.onSearchClick(filters)
    }
  }

  // Validar filtros cuando cambian y mostrar/ocultar alert según corresponda
  useEffect(() => {
    const hasRequiredFilters = validateRequiredFilters(props.selectedFilters)

    // Si no hay filtros seleccionados, mostrar alert (estado inicial)
    if (props.selectedFilters.length === 0) {
      setShowValidationAlert(true)
    }
    // Si hay filtros pero ninguno es obligatorio, mostrar alert
    else if (!hasRequiredFilters) {
      setShowValidationAlert(true)
    }
    // Si hay filtros obligatorios, ocultar alert
    else {
      setShowValidationAlert(false)
    }
  }, [props.selectedFilters])

  return (
    <Box>
      <FilterComponent
        options={filterOptions}
        {...props}
        onSearchClick={handleSearchWithValidation}
        requiredFilterKeys={['sku', 'ean13', 'pickingRouteId', 'asnId']}
        extraActions={props.extraActions}
      />
      {showValidationAlert && (
        <Box mb={2}>
          <Paper
            elevation={1}
            style={{
              backgroundColor: '#fff3cd',
              border: '1px solid #ffeaa7',
              borderRadius: '4px',
              padding: '12px 16px'
            }}
          >
            <Box display='flex' alignItems='center'>
              <WarningIcon
                style={{
                  color: '#856404',
                  marginRight: '8px',
                  fontSize: '20px'
                }}
              />
              <Typography
                variant='body2'
                style={{
                  color: '#856404',
                  fontWeight: 500
                }}
              >
                Para realizar la búsqueda, debe seleccionar al menos uno de los
                siguientes filtros: <strong>SKU</strong>, <strong>EAN13</strong>{' '}
                o <strong>Ruta Picking</strong> o <strong>ID de ASN</strong>.
              </Typography>
            </Box>
          </Paper>
        </Box>
      )}
    </Box>
  )
}
